import { SettingsGroupsInverse } from 'app/helper/utils';


export class Machine {
  id?: string;
  name: number;
  description?: string;
  configurations?: number[];
  color?: string;

  constructor(machine) {
    if (machine.id) { this.id = machine.id; }
    this.name = machine.name;
    if (machine.description) { this.description = machine.description; }
    if (machine.configurations) { this.configurations = machine.configurations; }
    if (machine.color) { this.color = machine.color; }

  }

  getConfigurationsAsIdsArray(configs) {
    const temp = {};
    if (configs) {
      configs.forEach(c => {
        temp[SettingsGroupsInverse[c.group]] = c.id;
      });
      return temp;
    }
  }
}
